import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { getPriceWithCurrency } from 'shared/helpers/transportInfo';
import { generateSparesSearchUrl } from 'shared/helpers/urls';
import Link from 'shared/components/Link/Link';
import SpareImg from 'shared/components/SpareImg';
import s from './SparesForAdvert.css';

const isMobile = __APP__ === 'mobile';

class SparesForAdvert extends React.Component {
  static propTypes = {
    spares: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    make: PropTypes.shape(),
    model: PropTypes.shape(),
    sparesLink: PropTypes.string.isRequired,
    //
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    make: null,
    model: null,
  };

  generateUrl = slug => `/${generateSparesSearchUrl({})}/${slug}`.replace(/\/\//g, '/');

  render() {
    const { intl, sparesLink } = this.props;
    const { spares, make, model } = this.props;
    const title =
      make || model
        ? `${make.title || ''} ${model.title || ''}`
        : intl.formatMessage({ id: 'данной модели' });

    const rootClass = isMobile ? s.rootMobile : s.root;

    return (
      <div className={rootClass}>
        <div className={s.title}>
          <FormattedMessage id="Запчасти для" /> {` ${title}`}
        </div>
        <div className={s.wrapper}>
          {spares.map(({ id, permalink, rubric, price, photos, currency }) => {
            const link = permalink || this.generateUrl(id);
            return (
              <div className={s.spare} key={id}>
                <Link to={link}>
                  <SpareImg photos={photos} />
                </Link>
                <div className={s.spareInfo}>
                  {rubric &&
                    <Link className={s.spareTitle} to={link}>
                      {rubric.title}
                    </Link>}
                  {price &&
                    <div className={s.sparePrice}>
                      {(price.some(p => p.value) && getPriceWithCurrency(price, currency.slug)) ||
                        intl.formatMessage({ id: 'договорная' })}
                    </div>}
                </div>
              </div>
            );
          })}
        </div>
        <Link className={s.allSpares} to={sparesLink}>
          <FormattedMessage id="Все запчасти для" /> {` ${title}`}
        </Link>
      </div>
    );
  }
}

export default withStyles(s)(injectIntl(SparesForAdvert));



// WEBPACK FOOTER //
// ./src/shared/components/SparesForAdvert/SparesForAdvert.js